__turbopack_context__.v({
  "card": "Locations-module__-SlKmG__card",
  "card__copy": "Locations-module__-SlKmG__card__copy",
  "card__image": "Locations-module__-SlKmG__card__image",
  "cards": "Locations-module__-SlKmG__cards",
  "copy": "Locations-module__-SlKmG__copy",
  "locations": "Locations-module__-SlKmG__locations",
});
